import { render, staticRenderFns } from "./BaseButtonResponsive.vue?vue&type=template&id=210a5b05&scoped=true&"
import script from "./BaseButtonResponsive.vue?vue&type=script&lang=js&"
export * from "./BaseButtonResponsive.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonResponsive.vue?vue&type=style&index=0&id=210a5b05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a5b05",
  null
  
)

export default component.exports